<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row" v-if="userData.permissions['insurance_patients']==1">
        <div class="col-12">
          <div class="card">
            <div class="card-body">

              <!-- <div class="mb-2 float-end">
                <b-button v-b-modal.new-insurance-company size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Insurance Company</b-button>
              </div> -->
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(services)="data">
                  <!-- <b-button @click="edit(data.item.patient_id,data.item.name,data.item.gender,data.item.telephone )" type="button" class="btn-sm btn" variant="info" v-b-modal.edit> <i class="mdi mdi-eye"></i> view</b-button> -->
                  <div class="btn-group">
                  <!-- <router-link :to="{ path: '/insuranceprofile',  query: { id: data.item.patient_id }}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-eye"></i> view</router-link> -->
                  <router-link :to="{ path: '/insuranceprofile',  query: { id: data.item.patient_id, visit_id: data.item.visit_id }}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-eye"></i> view</router-link>

                </div>
                </template>
                <!-- <template #cell(name)="data">
                {{ data.item.patients.name }}
   
              </template> -->
    
              <!-- <template #cell(id)="data">
                {{ data.item.patients.patient_id }}
               

              </template>
                <template #cell(insurance_company)="data">
                {{ data.item.companies.name }}
              </template> -->
              <!-- <template #cell(package)="data">
                {{ data.item.packages.name }}
              </template> -->
               <!-- <template #cell(telephone)="data">
                {{ data.item.telephone }}
              </template>
              <template #cell(address)="data">
                {{ data.item.patients.address }}
              </template>  -->
                <!-- <template #cell(actions)="data">
                  <div class="btn-group">
                  <b-button @click="edit(data.item.id,data.item.name,data.item.contact,data.item.email,data.item.address)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template> -->
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row justify-content-center">
          <div class="col-md-8 col-xl-6">
            <div>
              <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
              <center><span class="text-primary h6">You have no permission to View Refered Patients</span></center>
            </div>
          </div>
        </div>
      </div>
    
      <!-- <b-modal id="view-visit" centered title="View Patient Visit" title-class="font-14" hide-footer>
      <h6 class="text-dark"> Name : <span class="text-primary">{{ name }}</span>
       Gender : <span class="text-primary">{{ gender }}</span>
       Telephone : <span class="text-primary">0{{ telephone }}</span></h6>
      <table class="table table-sm mt-2" style="color: black;" density="compact">
      <thead><tr><th>Service Category</th><th>Service Name</th><th>Price</th></tr></thead>
        <tbody>
        <tr v-for="item in services" :key="item.id">
            <td>{{ item.service_category.name }}</td>
            <td>{{ item.service_name.name }}</td>
            <td>{{ item.service_price }}</td>
            </tr>
        </tbody>
      </table>
      <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('view-visit')" >Close</b-button>
      </div>
    </b-modal> -->
  
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { insurancesMethods, insurancesComputed, insurancevisitMethods, insurancevisitComputed,packagesMethods,packagesComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Insurance Patients",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader,
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Insurance Patients",
        items: [ {text: "Dashboard",to: "/",}, {text: "Insurance Patients",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'patient_id', label: 'ID', visible: true },
          { key: 'name', label: 'Name', visible: true },
          { key: 'visit_id', label: 'Visit_id', visible: false },

          // { key: 'gender', label: 'Gender', visible: true },
          // { key: 'age', label: 'Age', visible: true },
          { key: 'telephone', label: 'Telephone', visible: true },
          { key: 'address', label: 'Address', visible: true },
          { key: 'insurance_company', label: 'Insurance Company', visible: true },
          { key: 'insurance_package', label: 'Package', visible: true },
          // { key: 'insurance_service', label: 'Services', visible: true },
          { key: 'services', label: 'Serivces', visible: true },
          ],
        id:'',
        name:'',
        email:'',
        contact:'',
        address:'',
        telephone:'',
        nationality:'',
        gender:'',
        dateofbirth:'',
        insurancedpatients:[],
        // insurancepatients:[],
        compaines:[],
        patients:[],

       services:[],
        packages:[],
        visits:[],
      };
    },
    computed: {
      ...insurancesComputed,
      ...packagesComputed,
      ...insurancevisitComputed,
      List() { return this.insurancepatients.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.insurancepatients.map((d) => ({...d }))},
     
      IsBusy() { let a=false; if (this.insurancepatients.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchInsurances();
      this.fetchInsurancePackages();
      this.fetchInsuranceVisits();
    
      this.TotalRows = this.insurancepatients.length;
      this.isBusy=false;
    },
    methods: {
      ...insurancesMethods,
      ...packagesMethods,
      ...insurancevisitMethods,
      customLabel ({ patient_id, name, telephone }) {
        return `${patient_id} – ${name} – ${telephone}`
      },
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
     
      async edit(id,name,gender,telephone){
      this.id=id;
      this.name=name;
      this.gender=gender;
      this.telephone=telephone;
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/patientvisit";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.services=response.data.visits;
        this.$bvModal.show('view-visit')
      }
    })
    },
     
      remove(id,name){
        this.id=id;
        this.name=name;
        this.$bvModal.show('delete-insurance-company')
      },
      async addInsuranceCompany() { 
        let formData = new FormData();
        formData.append("name", this.name);
        formData.append("contact", this.contact);
        formData.append("email", this.email);
        formData.append("address", this.address);
        let url = "/addinsurance";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchInsurances();
            this.$bvModal.hide('new-insurance-company');
            this.name="";
            this.contact="";
            this.email="";
            this.address="";
            this.$toast.success("New Insurance Company Added");
        }
        });
      },
    
      async editInsuranceCompany(){ 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("contact", this.contact);
      formData.append("email", this.email);
      formData.append("address", this.address);
      let url = "/updateinsurance";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchInsurances();
          this.$bvModal.hide('edit-insurance-company');
            this.name="";
            this.contact="";
            this.email="";
            this.address="";
            this.$toast.success("Insurance Company Updated");
        }
      });
      },
      async removeInsuranceCompany() { 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      let url = "/removeinsurance";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchInsurances();
          this.$bvModal.hide('delete-insurance-company');
          this.$toast.error("Insurance Company Deleted");
        }
      });
      },
    },
  };
  </script>